import {isPlainObj} from 'ramda-adjunct';

import {FILTER_VALUE_KEY} from '../constants/filterValueKey';

/**
 * Unwraps a single filter entry from the `{value: X}` envelope used by EagGrid's
 * internal filter state.
 *
 * Returns the inner `value` when `rawValue` is a plain object carrying the
 * `FILTER_VALUE_KEY` key; otherwise returns `rawValue` unchanged (so it is safe
 * to call on already-unwrapped entries).
 *
 * Shared per-entry core of `unwrapFilterValues` and `unwrapFilterValuesRaw`.
 */
export const unwrapFilterValue = (rawValue: unknown): unknown =>
  isPlainObj(rawValue) && FILTER_VALUE_KEY in (rawValue as Record<string, unknown>)
    ? (rawValue as Record<string, unknown>)[FILTER_VALUE_KEY]
    : rawValue;
